import { useEffect, useState } from "react"
import myStyles from "../../styles/NotificationsForm.module.css"
import { Checkbox } from "primereact/checkbox"
import { classNames } from "primereact/utils"

const SettingsTable = ({
  values,
  setFieldValue,
  showAdvanceSettings,
}) => {
  const [rows, setRows] = useState([])

  useEffect(() => {
    if (showAdvanceSettings) {
      setRows(values)
    } else {
      setRows(values.filter((rowData) => rowData.isAll))
    }
  }, [showAdvanceSettings, values])

  // ✅ Ensure all checkboxes in a column are properly updated
  const handleIndividualCheckboxChange = (rowIndex, fieldName, checked) => {
    const updatedValues = values.map((item, index) => {
      if (index === rowIndex) {
        return { ...item, [fieldName]: checked }
      }
      return item
    })

    // Check if all individual checkboxes are now checked
    const allChecked = updatedValues
      .filter((item) => !item.isAll) // Ignore "All Notifications"
      .every((item) => item[fieldName])

    // Update "All Notifications" row accordingly
    updatedValues[0][fieldName] = allChecked

    setFieldValue("mutedEventTypes", updatedValues)
  }

  // ✅ Toggle all checkboxes when "All Notifications" is clicked
  const handleAllNotificationsToggle = (fieldName, checked) => {
    const updatedValues = values.map((item) => ({
      ...item,
      [fieldName]: checked, // Set all checkboxes in the column
    }))

    setFieldValue("mutedEventTypes", updatedValues)
  }

  // ✅ Render individual checkboxes
  const renderCheckBoxField = (rowData, fieldName, index) => (
    <div className={myStyles.settings_table_cell}>
      <Checkbox
        checked={rowData[fieldName]}
        onChange={(e) =>
          handleIndividualCheckboxChange(index, fieldName, e.checked)
        }
      />
    </div>
  )

  // ✅ Render "All Notifications" checkbox
  const renderAllNotificationsItem = (fieldName) => {
    const allChecked = values
      .filter((item) => !item.isAll)
      .every((item) => item[fieldName])

    return (
      <div
        className={classNames(
          myStyles.settings_table_cell,
          showAdvanceSettings && myStyles.purple_bk
        )}
      >
        <Checkbox
          checked={allChecked}
          onChange={(e) => handleAllNotificationsToggle(fieldName, e.checked)}
        />
      </div>
    )
  }

  // ✅ Render friendly name column
  const renderFriendlyName = (rowData) => (
    <div
      className={classNames(
        myStyles.settings_table_cell,
        rowData.isAll && showAdvanceSettings && myStyles.purple_bk
      )}
    >
      {rowData.friendlyName}
    </div>
  )

  return (
    <table
      className={classNames(
        myStyles.settings_table,
        showAdvanceSettings ? myStyles.full_table : ""
      )}
    >
      <thead>
        <tr>
          <th>Type</th>
          <th>E-mail</th>
          <th>SMS</th>
          <th>Online</th>
          <th>Sound</th>
        </tr>
      </thead>
      <tbody>
        {rows &&
          rows.map((rowData, index) => (
            <tr
              key={index}
              className={classNames(rowData.isAll ? myStyles.isAll : "")}
            >
              <td>{renderFriendlyName(rowData)}</td>
              <td>
                {rowData.isAll
                  ? renderAllNotificationsItem("channelEmail")
                  : renderCheckBoxField(rowData, "channelEmail", index)}
              </td>
              <td>
                {rowData.isAll
                  ? renderAllNotificationsItem("channelSMS")
                  : renderCheckBoxField(rowData, "channelSMS", index)}
              </td>
              <td>
                {rowData.isAll
                  ? renderAllNotificationsItem("channelSignalR")
                  : renderCheckBoxField(rowData, "channelSignalR", index)}
              </td>
              <td>
                {rowData.isAll
                  ? renderAllNotificationsItem("sound")
                  : renderCheckBoxField(rowData, "sound", index)}
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  )
}

export default SettingsTable
